import type { HTMLAttributes, PropsWithChildren } from 'react';
import styled, { css } from 'styled-components';
import { focusVisibleMixin } from '@elfsight/widget-ui';
import { getHandleActionKeyDown } from '@elfsight/widget-utils';

interface ArrowProps extends PropsWithChildren, HTMLAttributes<HTMLDivElement> {
  onClick: () => void;
}

export function Arrow({ children, onClick, ...restProps }: ArrowProps) {
  return (
    <Component
      role="button"
      tabIndex={0}
      onClick={onClick}
      onKeyDown={getHandleActionKeyDown(onClick)}
      {...restProps}
    >
      {children}
    </Component>
  );
}

const Component = styled.div`
  width: 64px;
  height: 64px;
  background-color: rgba(255, 255, 255, 0.08);
  position: absolute;
  top: 50%;
  transition: 0.3s ease all;
  cursor: pointer;
  transform: translateY(-50%);
  display: flex;
  justify-content: center;
  align-items: center;
  user-select: none;
  z-index: 999999;

  &:hover,
  &:focus-visible {
    background-color: rgba(255, 255, 255, 0.38);
  }

  ${focusVisibleMixin()}

  svg {
    fill: #fff;
  }

  ${({ theme: { windowWidth } }) =>
    windowWidth <= 608 &&
    css`
      top: auto;
      transform: translateY(0);
      bottom: 0;
      width: 52px;
      height: 52px;
      background-color: rgba(255, 255, 255, 0.62);

      &:hover {
        background-color: rgba(255, 255, 255, 1);
      }

      svg {
        width: 36px;
        height: 36px;
        fill: #111;
      }
    `};
`;
